import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { getErrors, getResData } from "../../shared/utility";
import { getProfileImageStart, getProfileStart } from "./profile";
import { resetStore } from "../../storage";

export const signInStart = () => {
  return {
    type: actionTypes.AUTH_LOGIN_START,
  };
};

export const signInSuccess = (signInRes: any) => {
  return {
    type: actionTypes.AUTH_LOGIN_SUCCESS,
    signInRes,
  };
};

export const signInFailed = (error: string | any) => {
  return {
    type: actionTypes.AUTH_LOGIN_FAIL,
    error,
  };
};

export const signIn = (authData: any, handleMsisdnNotRecognizedError: (msisdn: string) => void) => {
  return async (dispatch: any) => {
    dispatch(signInStart());

    return axios
      .post(`/sign-in`, authData)
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        /* To handle when phone number is not registered */ 
        if(data?.errorCode === 116) handleMsisdnNotRecognizedError(authData.msisdn);

        if (!data.success) throw new Error(getErrors(data));

        localStorage.setItem("m-market-user-token", data.data?.accessToken);
        localStorage.setItem(
          "m-market-user-refresh-token",
          data.data?.refreshToken
        );
        localStorage.setItem("m-market-user-type", data.data?.type);

        return dispatch(signInSuccess(data.data));
      })
      .catch((err) => dispatch(signInFailed(getErrors(err))));
  };
};

// Confirm otp
export const confirmOtpStart = () => {
  return {
    type: actionTypes.AUTH_SIGNIN_CONFIRM_START,
  };
};

export const confirmOtpSuccess = (confirmOtpRes: any) => {
  return {
    type: actionTypes.AUTH_SIGNIN_CONFIRM_SUCCESS,
    confirmOtpRes,
  };
};

export const confirmOtpFailed = (error: any) => {
  return {
    type: actionTypes.AUTH_SIGNIN_CONFIRM_FAIL,
    error,
  };
};

export const confirmOtp = (otpData: any, isResetPassword: boolean, handleUserBlockedError: () => void) => {
  return async (dispatch: any) => {
    dispatch(confirmOtpStart());

    return axios
      .post( (isResetPassword ? `/password/reset/confirm` : `/sign-in/confirm`), otpData)
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        // To handle the 'user blocked' error after three failed attempts at OTP verification
        if(data?.errorCode === 117) handleUserBlockedError();

        if (!data.success) throw new Error(getErrors(data));

        localStorage.setItem("m-market-user-token", data.data?.accessToken || data.data?.resetPasswordToken);
        localStorage.setItem(
          "m-market-user-refresh-token",
          data.data?.refreshToken
        );
        // localStorage.setItem("resetPasswordToken", data.data?.resetPasswordToken);
        
        return dispatch(confirmOtpSuccess(data?.data));
      })
      .catch((err) => dispatch(confirmOtpFailed(getErrors(err))));
  };
};

// Confirm Sign-Up otp
export const confirmSignUpStart = () => {
    return {
      type: actionTypes.AUTH_SIGN_UP_CONFIRM_START,
    };
  };
  
  export const confirmSignUpSuccess = (confirmSignUpRes: any) => {
    return {
      type: actionTypes.AUTH_SIGN_UP_CONFIRM_SUCCESS,
      confirmSignUpRes,
    };
  };
  
  export const confirmSignUpFailed = (error: any) => {
    return {
      type: actionTypes.AUTH_SIGN_UP_CONFIRM_FAIL,
      error,
    };
  };

export const confirmSignUp = (otpData: any, handleUserBlockedError: () => void) => {
    return async (dispatch: any) => {
      dispatch(confirmSignUpStart());
  
      return axios
        .post(`/sign-up/confirm`, otpData)
        .then((response) => {
          if (!response) throw new Error("No Response");
  
          const data = getResData(response.data);
  
          // To handle the 'user blocked' error after three failed attempts at OTP verification
          if(data?.errorCode === 117) handleUserBlockedError();
  
          if (!data.success) throw new Error(getErrors(data));
  
          localStorage.setItem("m-market-user-token", data.data?.accessToken || data.data?.resetPasswordToken);
          localStorage.setItem(
            "m-market-user-refresh-token",
            data.data?.refreshToken
          );
          
          return dispatch(confirmSignUpSuccess(data.data));
        })
        .catch((err) => dispatch(confirmSignUpFailed(getErrors(err))));
    };
};

// Register
export const signUpStart = () => {
  return {
    type: actionTypes.AUTH_REGISTER_START,
  };
};

export const signUpSuccess = (signUpRes: any) => {
  return {
    type: actionTypes.AUTH_REGISTER_SUCCESS,
    signUpRes,
  };
};

export const signUpFailed = (error: any) => {
  return {
    type: actionTypes.AUTH_REGISTER_FAIL,
    error,
  };
};

export const signUp = (signupData: any) => {
  return async (dispatch: any) => {
    dispatch(signUpStart());

    return axios
      .post(`/sign-up`, signupData)
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        if (!data.success) throw new Error(getErrors(data));

        localStorage.setItem("m-market-user-token", data.data?.accessToken);
        localStorage.setItem(
          "m-market-user-refresh-token",
          data.data?.refreshToken
        );
        localStorage.setItem("m-market-user-type", data.data?.type);

        return dispatch(signUpSuccess(data.data));
      })
      .catch((err) => dispatch(signUpFailed(getErrors(err))));
  };
};

export const logout = () => {
  return (dispatch: any) => {

    return axios
      .post(`/user/logout`, {
        refreshToken: localStorage.getItem("m-market-user-refresh-token"),
      })
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        localStorage.removeItem("m-market-user-token");
        localStorage.removeItem("m-market-user-refresh-token");

        if (!data.success) throw new Error(getErrors(data));
        dispatch(resetStore());
        dispatch(getProfileStart());
        dispatch(getProfileImageStart());
        return dispatch({ type: actionTypes.AUTH_LOGOUT, data});
      })
      .catch((err) => err);
  };
};

// ----------- Resend OTP ----------- //
export const resendOtpStart = () => {
  return {
    type: actionTypes.RESEND_OTP_START,
  };
};

export const resendOtpSuccess = () => {
  return {
    type: actionTypes.RESEND_OTP_SUCCESS,
  };
};

export const resendOtpFailed = (error: any) => {
  return {
    type: actionTypes.RESEND_OTP_FAIL,
    error,
  };
};

export const resendOtp = (data:any) => {
  return async (dispatch: any) => {
    dispatch(resendOtpStart());

    return axios
      .post(`/password/reset/otp/resend`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        if (!data.success) throw new Error(getErrors(data));

        return dispatch(resendOtpSuccess());
      })
      .catch((err) => dispatch(resendOtpFailed(getErrors(err))));
  };
}

// ----------- Initialize Password Reset ----------- //
export const initPasswordResetStart = () => {
  return {
    type: actionTypes.INIT_PASSWORD_RESET_START,
  };
};

export const initPasswordResetSuccess = (data: any) => {
  return {
    type: actionTypes.INIT_PASSWORD_RESET_SUCCESS,
    data : data,
  };
};

export const initPasswordResetFailed = (error: any) => {
  return {
    type: actionTypes.INIT_PASSWORD_RESET_FAIL,
    error,
  };
};

export const initPasswordReset = (data:any) => {
  return async (dispatch: any) => {
    dispatch(initPasswordResetStart());

    return axios
      .post(`/password/reset/init`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response?.data?.errorCode){
          dispatch(initPasswordResetFailed(response?.data?.message));
          return response.data;
        }
        return dispatch(initPasswordResetSuccess(response?.data));
      })
      .catch((err) => dispatch(initPasswordResetFailed(getErrors(err))));
  };
};

// ----------- Reset Password ----------- //
export const resetPasswordStart = () => {
  return {
    type: actionTypes.RESET_PASSWORD_START,
  };
};

export const resetPasswordSuccess = (data: any) => {
  return {
    type: actionTypes.RESET_PASSWORD_SUCCESS,
    data : data,
  };
};

export const resetPasswordFailed = (error: any) => {
  return {
    type: actionTypes.RESET_PASSWORD_FAIL,
    error,
  };
};

export const resetPassword = (data:any) => {
  return async (dispatch: any) => {
    dispatch(resetPasswordStart());

    return axios
      .post(`/password/reset`, data)
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        if (!data.success) throw new Error(getErrors(data));

        localStorage.setItem("m-market-user-token", data?.data?.accessToken);
        localStorage.setItem(
          "m-market-user-refresh-token",
          data?.data?.refreshToken
        );

        return dispatch(resetPasswordSuccess(data));
      })
      .catch((err) => dispatch(resetPasswordFailed(getErrors(err))));
  };
};

// ----------- Support Info ----------- //
export const getSupportInfoStart = () => {
  return {
    type: actionTypes.GET_SUPPORT_INFO_START,
  };
};

export const getSupportInfoFinish = () => {
  return {
    type: actionTypes.GET_SUPPORT_INFO_FINISH,
  };
};

export const getSupportInfo = () => {
  return async (dispatch: any) => {
    dispatch(getSupportInfoStart());

    return axios
      .get(`/support/metadata`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response?.data?.errorCode){
          console.error(getErrors(response?.data?.message));
        }
        localStorage.setItem("m-market-support-info", JSON.stringify(response?.data?.data || null));
        return dispatch(getSupportInfoFinish());
      })
      .catch((err) => {
        console.error(getErrors(err));
        return dispatch(getSupportInfoFinish());
      });
  };
};

export const signInResendOtp = async () => {
  try {
    const response = await axios.post(`/otp/resend`);

    if (!response) throw new Error("No Response");

    const resData = getResData(response.data);

    if (!resData.success) throw new Error(getErrors(resData));

    // Return data to handle toast outside
    return resData;
  } catch (err: any) {
    throw new Error(getErrors(err));
  }
};